"use strict";

define('adapter/paginate',['underscore', './param'], function (_, ParamAdapter) {
  var Adapter = ParamAdapter.extend({
    omit: ['size'],
    postprocess: function postprocess(data, resp) {
      this.model.set(_.omit(resp.page, this.omit));
    }
  });
  return Adapter;
});

